import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldKeyhole: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield-keyhole"><path d="M12 14.75V9M12 2.75L20.25 5.5V11.9123C20.25 16.8848 16 19.25 12 21.4079C8 19.25 3.75 16.8848 3.75 11.9123V5.5L12 2.75ZM13.5 10.25C13.5 11.0784 12.8284 11.75 12 11.75C11.1716 11.75 10.5 11.0784 10.5 10.25C10.5 9.42157 11.1716 8.75 12 8.75C12.8284 8.75 13.5 9.42157 13.5 10.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShieldKeyhole;
